// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__qNj09","errors":"Errors_errors__DnSoF"};